import { Component, OnInit, HostListener, AfterViewInit, OnDestroy, ChangeDetectorRef, Inject, ViewChild, ElementRef,ViewContainerRef, ComponentRef, Injector, inject, EnvironmentInjector, createComponent} from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { PlatformDetect } from '@libs/platform/platform-detect';
import { FactoryService } from '@services/common/factory.service';
import { CommonService } from '@services/common/common.service';
import { getViewWidth } from '@core/utils/util';
import { debounce } from '@core/utils/debouce';
import { DisplayMode } from '@shdr/ditto-ui/header';
import { getViewHeight } from '@core/utils/util';
import { ComRouteService } from '@services/common/com-route.service';
import { bussinessCodeMap } from '@core/libs/config/profile-mapping';
import { FooterComponent } from '@shdr/ditto-ui/footer';
import { HeaderWithNoticeBarComponent } from '@shdr/ditto-ui/header-with-notice-bar';
import { IconSymbolComponent } from '@shdr/ditto-ui/icon';
import { AccessibilityService } from '@services/accessibility/accessibility.service';
import { ComActionService } from '@services/common/com-action.service';
import { ComSubService } from '@services/common/com-sub.service';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
  
export class AppComponent implements OnInit, OnDestroy, AfterViewInit{
  injector = inject(Injector);
  public isWeb: boolean = false;
  public isPcWeb: boolean = false;
  public showError: boolean = false;
  public routerSub: Subscription;
  public showLoading: boolean = false;
  public showVirtualPhonePop: boolean; //virtual-phone popup
  public showForgetPwdPop: boolean; //gorget password popup
  public showCaptcha: boolean = false;
  public currentUrl: string;
  public cdnBaseURL = this.factorySer.getCNDUrl();
  public viewWidth: number = getViewWidth();
  public isWebLoginBg: boolean = false; // pc web login
  public showBigView: boolean = false; //show mobile UI in big size page
  public isGuestPage: boolean = false; //use for check is the guest-info page
  public displayMode = DisplayMode.Regular;
  public disableCeiling = false; // 是否禁用吸顶
  public isShowAnimation: boolean = false;
  public isShowBreadcrumb: boolean = true; // footer是否展示面包屑

  // pc/mobile web端登录后, 展示header和footer
  public isShowHeaderAndFooter = false;
  public isMbileHeader = false;
  public isPcHeader = false;
  public isHorizonScreen = false; // 是否横屏
  public isNotlanding = true; // web端landing页样式单独处理
  
  @ViewChild('imgBg') imgBg: ElementRef;

  @ViewChild('headerContainer', { read: ViewContainerRef })
  headerContainer!: ViewContainerRef;

  @ViewChild('footerContainer', { read: ViewContainerRef })
  footerContainer!: ViewContainerRef;

  @ViewChild('iconSymbolContainer', { read: ViewContainerRef })
  iconSymbolContainer!: ViewContainerRef;

  private headerWithNoticeBartComponentRef!: ComponentRef<HeaderWithNoticeBarComponent>;
  private footerComponentRef!: ComponentRef<FooterComponent>;
  private iconSymbolComponentRef!: ComponentRef<IconSymbolComponent>;


  private hasLoadHeaderWithNoticeBarComponent = false;
  private hasLoadFooterComponent = false;
  private hasLoadIconSymbolComponent = false;

  private headerWithNoticeBarComponent;
  private iconSymbolComponent;
  private footerComponent;
  
  constructor(
    private router: Router,
    private platform: PlatformDetect,
    private comSer: CommonService,
    private comRoute: ComRouteService,
    private changeDR: ChangeDetectorRef,
    private accessibilitySer: AccessibilityService,
    private comActSer: ComActionService,
    private comSubSer: ComSubService,
    public factorySer: FactoryService
  ) {
    this.initData();
  }

  @HostListener('window:resize', ['$event'])
  @debounce(200)
  windowResizeListener(e): void {
    this.viewWidth = getViewWidth();
  }

  // 横竖排切换监听
  @HostListener('window:orientationchange', ['$event'])
  @debounce(200)
  orientationchange(e): void {
    this.isHorizonScreen = !window.matchMedia("(orientation: portrait)").matches;
    this.viewWidth = getViewWidth();
    this.initBigView();
  }

  @HostListener('click', ['$event'])
  clickEvent(e) { 
    const name = e.target.className;
    this.comSer.linkAction(name);
  }

  ngOnInit(): void {
    console.log('init Platform:', this.platform.detect());
    console.log('init userAgent..', window.navigator.userAgent);
    this.checkSubEvent();
    this.isSafari();
    const pathName = location.pathname;
    const wxAuthLoading = /(cookie-loading)/.test(pathName);
    // 微信授权回调页面不需要应用初始化处理
    if (!wxAuthLoading) {
      this.factorySer.setUrlParams();
      this.routerSub = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          if (this.platform.isWx() && !this.factorySer.closedWxMenu) { 
            this.factorySer.closedWxMenu = true;
            wx.hideOptionMenu();
            wx.hideAllNonBaseMenuItem();
            wx.hideMenuItems({
              menuList: ['menuItem:share:timeline', 'menuItem:copyUrl', 'menuItem:share:appMessage', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:editTag', 'menuItem:delete', 'menuItem:copyUrl', 'menuItem:originPage', 'menuItem:readMode', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand']
            });
          }
  
          this.checkInitStatus(event.url);
          // 路由切换时，关闭captcha
          if(this.showCaptcha) {
            this.comSer.showCaptchaSub.next(false);
          }
          if(this.factorySer.isWebStyle || this.factorySer.isMobileWebStyle) {
            this.changeBgAndHeader(event.url,this.factorySer.isWebStyle,this.factorySer.isMobileWebStyle);
            // web端每次切换页面时置顶
            document.body.scrollTo(0,0);
          }
          this.isGuestPage = /(guest-list)|(guest-edit)/.test(event.url);
        });
      this.initBigView();
    }
  }

  private async initData() { 
    this.comSubSer.refreshLoading(true);
    this.showVirtualPhonePop = sessionStorage.getItem('showVirtualPhonePop') === 'true' && sessionStorage.getItem('captchaPssed') === 'true';
    this.isPcWeb = this.platform.isPcWeb();
    if(this.platform.isWeb()) {
      this.initHeaderStyle();
    }
  }

  ngAfterViewInit() { 
    this.comActSer.hideCloseBtn(); // close app loading page
    setTimeout(() => {
      if (this.comSubSer.showLoading) this.comSubSer.refreshLoading(false);
    }, 3000);
    if (this.platform.isApp()) { 
      this.accessibilitySer.checkAccessibilityStatus();
    }
    console.log('app viewHeight..', getViewHeight());
  }

  isSafari() {
    const ua = navigator.userAgent;
    this.factorySer.isSafari = ua.includes('AppleWebKit') && ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('Edg');
  }

  initHeaderStyle() {
    document.documentElement.clientWidth > 768 && (this.isPcWeb || this.platform.isIPad()) 
      ? this.factorySer.isWebStyle = true 
      : this.factorySer.isMobileWebStyle = true;
  }

  initBigView() {
    this.showBigView = this.viewWidth > 480 && (this.viewWidth <= 768 || this.viewWidth > 768 && !this.factorySer.isWebStyle);
  }

  private checkSubEvent() { 
    this.comSubSer.showLoadingSync.subscribe(resp => { 
      this.showLoading = resp;
      this.changeDR.detectChanges(); 
    });

    this.comSer.showReminderSub.subscribe(resp => { 
      if (resp) this.showVirtualPhonePop = true;
    })

    this.comSer.showForgetSub.subscribe(resp => { 
      if (resp) { 
        this.showForgetPwdPop = true;
      }
    })

    this.comSer.showCaptchaSub.subscribe(resp => { 
      this.showCaptcha = !!resp;
      this.comSer.setHiddenAria(this.showCaptcha);
      if (resp) { 
        sessionStorage.removeItem('captchaPssed');
        this.comSer.triggerCaptchaSub.next(true);
      }
    })

    this.comSer.showErrorSub.subscribe(resp => { 
      this.showError = resp;
      this.comSubSer.refreshLoading(false);
      this.changeDR.detectChanges(); 
    });
  }

  async appendHeaderAndIconComponent() {
    const appNodeInjector = this.injector;
    const appStandaloneInjector = this.injector.get(EnvironmentInjector);
    if(this.hasLoadHeaderWithNoticeBarComponent || this.hasLoadIconSymbolComponent) return;

    if(!this.headerWithNoticeBartComponentRef) {
      const { HeaderWithNoticeBarComponent } = await import('@shdr/ditto-ui/header-with-notice-bar');
      this.headerWithNoticeBarComponent = HeaderWithNoticeBarComponent;
    }
    this.headerWithNoticeBartComponentRef = createComponent(this.headerWithNoticeBarComponent, {
      environmentInjector: appStandaloneInjector,
      elementInjector: appNodeInjector,
    });

    if(!this.iconSymbolComponentRef) {
      const { IconSymbolComponent } = await import('@shdr/ditto-ui/icon');
      this.iconSymbolComponent = IconSymbolComponent;
    }
    this.iconSymbolComponentRef = createComponent(this.iconSymbolComponent, {
      environmentInjector: appStandaloneInjector,
      elementInjector: appNodeInjector,
    });

    this.headerWithNoticeBartComponentRef.setInput('displayMode', this.displayMode);
    this.headerWithNoticeBartComponentRef.setInput('disableCeiling',this.disableCeiling);

    if(!this.hasLoadHeaderWithNoticeBarComponent) {
      this.headerContainer.insert(this.headerWithNoticeBartComponentRef.hostView);
      this.hasLoadHeaderWithNoticeBarComponent = true;
    }

    if(!this.hasLoadIconSymbolComponent) {
      this.iconSymbolContainer.insert(this.iconSymbolComponentRef.hostView);
      this.hasLoadIconSymbolComponent = true;
    }

    if(!this.isShowHeaderAndFooter) {
      this.destroyDynamicComponent();
    }
  }

  async appendfooterComponent() {
    if(this.hasLoadFooterComponent) return;
    const appNodeInjector = this.injector;
    const appStandaloneInjector = this.injector.get(EnvironmentInjector);

    if(!this.footerComponentRef) {
      const { FooterComponent } = await import('@shdr/ditto-ui/footer')
      this.footerComponent = FooterComponent;
    }
    this.footerComponentRef = createComponent(this.footerComponent, {
      environmentInjector: appStandaloneInjector,
      elementInjector: appNodeInjector,
    });
    this.footerComponentRef.setInput('isShowAnimation', this.isShowAnimation);
    this.footerComponentRef.setInput('isShowBreadcrumb',this.isShowBreadcrumb);
    this.footerComponentRef.setInput('footerBreadcrumbData',this.factorySer.footerBreadcrumbData);

    if(!this.hasLoadFooterComponent) {
      this.footerContainer.insert(this.footerComponentRef.hostView);
      this.hasLoadFooterComponent = true;
    }

    if(!this.isShowHeaderAndFooter) {
      this.destroyDynamicComponent();
    }
  }
  
  private destroyDynamicComponent(){
    this.headerWithNoticeBartComponentRef?.destroy()
    this.iconSymbolComponentRef?.destroy();
    this.footerComponentRef?.destroy();
    this.headerWithNoticeBartComponentRef = null;
    this.iconSymbolComponentRef = null;
    this.footerComponentRef = null;
    this.headerContainer?.clear();
    this.footerContainer?.clear();
    this.iconSymbolContainer?.clear();
    this.hasLoadHeaderWithNoticeBarComponent = false;
    this.hasLoadFooterComponent = false;
    this.hasLoadIconSymbolComponent = false;
  }
  async checkInitStatus(curUrl: string) { 
    // close virtual-phone popup when router change
    const validUrl = /(login)|(change-phone-new)/.test(curUrl);
    if (this.showVirtualPhonePop && !validUrl) {
      this.btnAction(); 
    }
    
    //remove temp session values
    if (curUrl !== '/shprofile/edit-pwd/reset-pwd') { 
      sessionStorage.removeItem('tmpP');
    }
  }

  public captchaEmit(val: any, key: string) { 
    let timmer = setTimeout(() => { 
      this.showCaptcha = false; 
      clearTimeout(timmer);
      timmer = null;
    }, val?.isAudioType? 2000 : 100); 
    if (key == 'pass') {
      this.comSer.captchaPassed(val);
    }
    if (key == 'close') {
      this.comSer.captchaClose();
    }
  }

  public btnAction(key?: string) { 
    switch (key) { 
      case 'cancel':
        this.showForgetPwdPop = false;
        this.factorySer.showSinglePop = false;
        this.factorySer.descPip = true; //descPip rollback to default true as use pip for desc in popup
        break;
      case 'phoneVerify':
      case 'emailVerify':
        this.factorySer.setResetType(key);
        this.showForgetPwdPop = false;
        this.comRoute.route('/edit-pwd/reset-verify');
        break;
      default:
        //close virtual-phone popup
        this.showVirtualPhonePop = false;
        this.comSer.clearnPhoneSub.next(true);
        sessionStorage.removeItem('captchaPssed');
        this.comSer.clearVirtualPhone();
        break;
    }
  }

  /**
   *  web端根据url和登录状态,改变样式
   */
  public changeBgAndHeader(url: string, webStyle, mobileWebStyle) {
    const logined = this.factorySer.getLoginStatus();
    this.isPcHeader = webStyle && logined;
    this.isMbileHeader = mobileWebStyle && logined;
    const isRegister = this.factorySer.isRegister;
    const isUpMember = this.factorySer.isUpMember;
    if(url.includes('shprofile/register')) { // 完善信息页无header无footer
      this.isWebLoginBg = webStyle;
      this.isPcHeader = false;
      this.isMbileHeader = false;
    } else if(url.includes('shprofile/member/landing')) { // landing页有header无footer
      this.isWebLoginBg = webStyle;
      this.isPcHeader = true;
      this.isNotlanding = false;
    } else if(url.includes('shprofile/visitor/guest')) { // guest页无header无footer
      this.isWebLoginBg = false; // for gr 灰底
      this.isPcHeader = false;
      this.isMbileHeader = false;
    } else if(url.includes('shprofile/pin-code') && logined && (isUpMember || isRegister)) { // 从完善信息页点击返回
      this.factorySer.setLoginStatus(false);
      this.isWebLoginBg = true;
      this.isPcHeader = false;
      this.isMbileHeader = false;
    }
     else if(!logined && webStyle){ // login flow无header无footer
      this.isWebLoginBg = true;
    } else {
      this.isWebLoginBg = false;
    }
    if(/shprofile\/login/.test(url)){ // 防止logined判断不及时导致登录页的header和footer显示
      this.isPcHeader = false;
      this.isMbileHeader = false;
    }
    // MO、GR、PBP场景在pc/mobile web端样式适配
    // 1.个人中心展示退出按钮 
    // 2.不展示header和footer
    const bussinessCodeList = [`${bussinessCodeMap.GR}`,`${bussinessCodeMap.MO}`,`${bussinessCodeMap.PBP}`];
    if(bussinessCodeList.includes(this.factorySer.getBusiness())){
      this.factorySer.isNotHeaderFooter = true;
      this.isShowHeaderAndFooter = false;
      return;
    }
    this.isShowHeaderAndFooter = this.isPcHeader || this.isMbileHeader;

    if(this.isShowHeaderAndFooter) {
      this.appendHeaderAndIconComponent();
      if (this.isNotlanding) { 
        this.appendfooterComponent();
      }
    }

    if(!this.isShowHeaderAndFooter) {
      this.headerContainer?.clear()
      this.footerContainer?.clear()
      this.iconSymbolContainer?.clear()
      this.hasLoadHeaderWithNoticeBarComponent = false;
      this.hasLoadIconSymbolComponent = false;
      this.hasLoadFooterComponent = false;
    }

    if(!this.isNotlanding) {
      this.footerContainer?.clear()
      this.hasLoadFooterComponent = false;
    }
  }

  ngOnDestroy() { 
    this.routerSub.unsubscribe();
    this.factorySer.clearCache();
    this.comSer.clearSubscribe();
    this.destroyDynamicComponent();
  }

}